// LAYOUT
import '../layout.js';

// SWIPER
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

// GSAP
import { gsap , ScrollSmoother , ScrollTrigger } from "../layout.js";
import { gsapSmoothScrollObj } from "../layout.js";

// LIGHTCASE VIDEO
import lightGallery from 'lightgallery';
// Plugins
import lgVideo from 'lightgallery/plugins/video';


// HOME BANNER
const topNav = document.querySelector('.top-navbar');
const nav = document.querySelector('.navbar-custom');
const homeBanner = document.querySelector('.home-banner');
const homeBannerImg = document.querySelector('.home-banner__holder');

var heightNavbar = nav.offsetHeight + topNav.offsetHeight;
if (window.innerWidth > 991) {
	homeBannerImg.style.top = nav.offsetHeight + "px";
	homeBanner.style.paddingTop = heightNavbar + "px";
	homeBanner.style.height = (window.innerHeight + heightNavbar) + "px";
} else {
	homeBannerImg.style.top = heightNavbar + "px";
	homeBanner.style.paddingTop = heightNavbar + "px";
	// homeBanner.style.height = (window.innerHeight + nav.offsetHeight) + "px";
}

// HOME ABOUT VIDEO
lightGallery(document.getElementById('about-video'), {
    plugins: [lgVideo],
});


// PROJECT SWIPER
var projectSwiper = new Swiper(".project-swiper", {
	modules: [Navigation, Pagination],
	slidesPerView: 1,
    spaceBetween: 50,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
	breakpoints: {
		768: {
			slidesPerView: 2,
		},
	},
});

// HOME SERVICE
const servicesList = document.querySelectorAll('.our-services__list-services-holder');
const servicesImage = document.querySelectorAll('.our-services__services-image');

for (const list of servicesList) {
    for (const img of servicesImage) {
      	list.addEventListener('mouseenter', () => {
	        img.style.visibility = "hidden";
	        img.style.opacity = 0;
	        if ( list.dataset.servicesImage == img.dataset.id ) {
	          	img.style.visibility = "visible";
	          	img.style.opacity = 1;
	        }
      	})
      	list.addEventListener('mouseleave', () => {
	        if ( list.dataset.servicesImage == img.dataset.id ) {
	          	img.style.visibility = "hidden";
	          	img.style.opacity = 0;
	        }
	        document.querySelector('.our-services__services-image:first-child').style.visibility = "visible";
      		document.querySelector('.our-services__services-image:first-child').style.opacity = 1;
      	})
    }
}


// MARQUEE
const marq = document.querySelector(".marquee");
const marqContent = document.querySelector(".marquee__text");
const containerWidth = marq.offsetWidth;
const contentWidth = marqContent.offsetWidth;
const clonesNeeded = Math.ceil(containerWidth / contentWidth) + 1;

const elements = [marqContent];
let separatorWidth = 0;  // Initialize separator width

// Clone the marq-content and append it to the marq container multiple times
for (let i = 0; i < clonesNeeded; i++) {
    const clonedContent = marqContent.cloneNode(true);
    marq.appendChild(clonedContent);
    elements.push(clonedContent);
}

// Speed control: set the desired speed in pixels per second
const desiredPixelsPerSecond = 100;

// Calculate the distance to animate (half the total width of all elements)
const totalWidth = (contentWidth + separatorWidth) * (clonesNeeded + 1);
const distanceToAnimate = totalWidth / 2;

// Calculate the animation duration based on the desired speed
const duration = totalWidth / desiredPixelsPerSecond;

// Create the GSAP timeline for the marquee animation
const marqueeTl = gsap.timeline({
    repeat: -1,
    paused: true
});

marqueeTl.fromTo(elements, duration, {
    x: 0
}, {
    x: -distanceToAnimate,
    ease: "Power1.easeInOut"
});

// Hide the loader after 1 second, fade in the marq container, and start the animation
setTimeout(() => {
    marq.style.visibility = 'visible';
    gsap.fromTo(marq, 1, { opacity: 1 }, {
        opacity: 1,
        onComplete: function() {
            marqueeTl.play();
        }
    });
}, 1000);

// Pause animation on mouseover
marq.addEventListener('mouseover', function() {
    marqueeTl.pause();
});

// Resume animation on mouseleave
marq.addEventListener('mouseleave', function() {
    marqueeTl.play();
});
